module.exports = __webpack_public_path__ + "img/brake.8414557b.png";